import React from "react";
import theme from "theme";
import { Theme, Text, Section } from "@quarkly/widgets";
import { Helmet } from "react-helmet";
import { GlobalQuarklyPageStyles } from "global-page-styles";
import { RawHtml, Override } from "@quarkly/components";
import * as Components from "components";
export default (() => {
	return <Theme theme={theme}>
		<GlobalQuarklyPageStyles pageUrl={"privacy-policy"} />
		<Helmet>
			<title>
				FitPro Gym Franchise
			</title>
			<meta name={"description"} content={"A FITNESS REVOLUTION DESIGNED FOR THE MODERN LIFESTYLE"} />
			<meta property={"og:title"} content={"FitPro Gym Franchise"} />
			<meta property={"og:description"} content={"A FITNESS REVOLUTION DESIGNED FOR THE MODERN LIFESTYLE"} />
			<meta property={"og:image"} content={"https://uploads.quarkly.io/67605a611b94b100243355fe/images/icon.png?v=2024-12-16T16:54:21.088Z"} />
			<link rel={"shortcut icon"} href={"https://uploads.quarkly.io/67605a611b94b100243355fe/images/icon.png?v=2024-12-16T16:54:21.088Z"} type={"image/x-icon"} />
			<link rel={"apple-touch-icon"} href={"https://uploads.quarkly.io/67605a611b94b100243355fe/images/icon.png?v=2024-12-16T16:54:21.088Z"} />
			<link rel={"apple-touch-icon"} sizes={"76x76"} href={"https://uploads.quarkly.io/67605a611b94b100243355fe/images/icon.png?v=2024-12-16T16:54:21.088Z"} />
			<link rel={"apple-touch-icon"} sizes={"152x152"} href={"https://uploads.quarkly.io/67605a611b94b100243355fe/images/icon.png?v=2024-12-16T16:54:21.088Z"} />
			<link rel={"apple-touch-startup-image"} href={"https://uploads.quarkly.io/67605a611b94b100243355fe/images/icon.png?v=2024-12-16T16:54:21.088Z"} />
			<meta name={"msapplication-TileImage"} content={"https://uploads.quarkly.io/67605a611b94b100243355fe/images/icon.png?v=2024-12-16T16:54:21.088Z"} />
			<meta name={"msapplication-TileColor"} content={"#232323"} />
		</Helmet>
		<Components.Header>
			<Override slot="text" />
		</Components.Header>
		<Section color="--light">
			<Text font="--headline2">
				{"  "}Privacy Policy
			</Text>
			<Text>
				{"  "}At FitPro Gym, we respect your privacy. This policy explains how we collect, use, store, and protect your personal information when you use our website and services.
			</Text>
			<Text font="--headline4">
				{"  "}Information Collection
			</Text>
			<Text>
				We may collect the following types of data:
				<br />
				<br />
				{"  "}- Your name, contact information, and email address.
				<br />
				{"  "}- Information regarding your gym membership, bookings, and related services.
				<br />
				{"  "}- Data about your preferences to improve the quality of our services.
			</Text>
			<Text font="--headline4">
				{"  "}Use of Information
			</Text>
			<Text>
				We use your data for:
				<br />
				<br />
				{"  "}- Processing your membership, bookings, and service requests.
				<br />
				{"  "}- Providing high-quality customer service.
				<br />
				{"  "}- Sending promotional emails, newsletters, and updates.
			</Text>
			<Text font="--headline4">
				{"  "}Data Protection
			</Text>
			<Text>
				{"  "}We employ modern encryption and security technologies to protect your information from unauthorized access, loss, or disclosure.
			</Text>
			<Text font="--headline4">
				{"  "}Sharing Information with Third Parties
			</Text>
			<Text>
				{"  "}We do not share your personal information with third parties, except in cases required by law or to facilitate the execution of our services through verified partners.
			</Text>
			<Text font="--headline4">
				{"  "}Your Rights
			</Text>
			<Text>
				You have the right to:
				<br />
				<br />
				{"  "}- Access your personal data.
				<br />
				{"  "}- Modify or delete your personal information.
				<br />
				{"  "}- Opt-out of receiving marketing emails.
			</Text>
			<Text font="--headline4">
				{"  "}Changes to the Policy
			</Text>
			<Text>
				{"  "}We reserve the right to update this policy at any time. All changes will be posted on this page.
			</Text>
			<Text font="--headline4">
				{"  "}Contact Us
			</Text>
			<Text>
				If you have any questions regarding our privacy policy, please contact us at info@fitprogym.com.
			</Text>
		</Section>
		<Components.Footer3 />
		<RawHtml>
			<style place={"endOfHead"} rawKey={"6166a2b829a0a1001e6ca5fb"}>
				{":root {\n  box-sizing: border-box;\n}\n\n* {\n  box-sizing: inherit;\n}"}
			</style>
		</RawHtml>
	</Theme>;
});